export const year = "w ciągu roku czynna we wszystkie dni powszednie w godzinach od 16:00 - 17:00.";
export const holiday = "W wakacje w poniedziałki, środy i piątki.";
export const officeImage = "./assets/calligraphy_1958382.png";

export const items = [
  {
    id: 1,
    name: "Chrzest",
    slug: "chrzest",
  },
  {
    id: 2,
    name: "I Komunia Święta",
    slug: "i-komunia-swieta",
  },
  {
    id: 3,
    name: "Bierzmowanie",
    slug: "bierzmowanie",
  },
  {
    id: 4,
    name: "Małżeństwo",
    slug: "malzenstwo",
  },
  {
    id: 5,
    name: "Sakrament pokuty",
    slug: "sakrament-pokuty",
  },
  {
    id: 6,
    name: "Namaszczenie chorych",
    slug: "namaszczenie-chorych",
  },
  { 
    id: 7,
    name: "Pogrzeb",
    slug: "pogrzeb",
  },
];

export const itemDetails = {
  1: {
    description: `Chrzest jest pierwszym i najważniejszym sakramentem chrześcijańskiego wtajemniczenia. Jest fundamentem całego życia chrześcijańskiego i bramą do życia w Duchu Świętym. Przez chrzest człowiek zostaje uwolniony od grzechu, odradza się jako dziecko Boże, zostaje włączony do Kościoła i staje się uczestnikiem życia Chrystusa.

Sam Chrystus ustanowił chrzest jako konieczny do zbawienia dla tych, którym głoszona jest Ewangelia i którzy mogą o niego poprosić. Sakrament chrztu jest udzielany przez polanie wodą lub zanurzenie w wodzie, wzywając imienia Trójcy Świętej: Ojca i Syna, i Ducha Świętego.

Co dokonuje się w czasie chrztu?

Przez chrzest człowiek otrzymuje przede wszystkim odpuszczenie wszystkich grzechów – zarówno grzechu pierworodnego, jak i wszystkich grzechów osobistych, jeśli chrzest przyjmuje osoba dorosła. Chrzest nie usuwa jednak wszystkich doczesnych konsekwencji grzechu, takich jak cierpienie, choroba czy śmierć.

Ochrzczony staje się nowym stworzeniem. Otrzymuje łaskę uświęcającą, zostaje przybranym dzieckiem Boga i świątynią Ducha Świętego. Przez chrzest zostaje również włączony w Kościół, Ciało Chrystusa.

Chrzest pozostawia w duszy niezatarty duchowy znak, dlatego sakrament ten może zostać przyjęty tylko raz.

Chrzest dzieci

Kościół udziela chrztu również małym dzieciom. Czyni to w wierze Kościoła, ponieważ zbawienie jest darmowym darem Boga i nie zależy od ludzkich zasług. Rodzice i chrzestni podejmują zobowiązanie, aby pomóc dziecku wzrastać w wierze i prowadzić je do życia zgodnego z Ewangelią.

Dlatego przyjęcie chrztu dziecka wiąże się z odpowiedzialnością rodziców za jego chrześcijańskie wychowanie. Ich zadaniem jest przede wszystkim własnym życiem, modlitwą i przykładem ukazywać dziecku wiarę w Chrystusa.

Chrzest a wiara

Chrzest jest początkiem drogi wiary, a nie jej zakończeniem. Łaska otrzymana w sakramencie powinna być rozwijana przez modlitwę, uczestnictwo w życiu Kościoła, słuchanie słowa Bożego, przyjmowanie Eucharystii i pozostałych sakramentów oraz codzienne życie według Ewangelii.

Chrzest jest więc początkiem nowego życia w Chrystusie – życia, które prowadzi człowieka ku pełnej jedności z Bogiem.`,
    quote: "Kto uwierzy i przyjmie chrzest, będzie zbawiony",
    quoteAuthor: "Mk 16,16",
    image: "/assets/church_15205025.png",
    documents: [
  "Dowody osobiste rodziców",
  "Akt urodzenia dziecka",
  "Akt małżeństwa kościelnego rodziców – jeśli dotyczy",
  "Zaświadczenia dla rodziców chrzestnych",
  "Świadectwa chrztu rodziców chrzestnych",
  "Zaświadczenie o nauce przedchrzcielnej – jeśli wymagane"
],
    dates: [
        {
            date: "W niedziele podczas Mszy Świętej o godz. 12:00",
            rule: "Także w innych terminach po uzgodnieniu z księdzem proboszczem" 
        }
    ],
    links: [
        {
            url: "http://www.katechizm.opoka.org.pl/kkkII-2-1.htm#o2kkkII-2-1",
            text: "Katechizm Kościoła Katolickiego – Chrzest"
        }
    ],
  },
  2: {
    description: "Pierwsza Komunia Święta to uroczyste przyjęcie Ciała i Krwi Pańskiej po raz pierwszy. Dzieci przygotowują się do tego sakramentu przez rok w ramach katechezy.",
    quote: "Kto spożywa moje Ciało i pije moją Krew, ma życie wieczne",
    quoteAuthor: "J 6,54",
    image: "/assets/church_15205025.png",
    documents: [
      "Świadectwo chrztu",
      "Świadectwo ukończenia I klasy szkoły podstawowej",
      "Zgoda rodziców"
    ],
    dates: [
        {
            date: "23 maja 2026",
            rule: "W niedzielę przed Odpustem Parafialnym" 
        }
    ],
    meetings: [
        {
            date: "16 września",
            time: "18:30",
            text: "W środę  po wieczornej Mszy Świętej w kościele odbędzie spotkanie z rodzicami dzieci klas trzcich związane z organizacją uroczystości."
        },
    ],
    announcements: [
        "Jesteś swój chłop. Tak się tylko mówi. Oczywiście jesteś mój chłop!",
        "Mnie też nikt nic nie dał za darmo. Wszystko musiałem sam odziedziczyć.",
        "Wyrzeknij się diabła! - nie mogę bo mam z nim trójkę dzieci..."
    ], 
    links: [
        {
            url: "http://www.katechizm.opoka.org.pl/kkkII-2-1.htm#o2kkkII-2-1",
            text: "Katechizm Kościoła Katolickiego – Eucharystia"
        }
    ],

  },
  3: {
    description: "Bierzmowanie umacnia dar Ducha Świętego otrzymany na chrzcie. Przygotowanie trwa zwykle dwa lata i kończy się przyjęciem sakramentu z rąk biskupa.",
    quote: "Przyjmij znamię daru Ducha Świętego",
    quoteAuthor: "Obrzęd bierzmowania",
    image: "/assets/church_15205025.png",
    documents: [
      "Świadectwo chrztu",
      "Świadectwo ukończenia katechezy",
      "Zaświadczenie od katechety"
    ],
    dates: ["Wielki Post - po uzgodnieniu z biskupem"],
    meetings: [
        {
            date: "9 września",
            time: "18:30",
            text: "W środę po wieczornej Mszy Świętej w kościele spotkanie kandydatów do bierzmowania dla klasy 6, 7 i 8"
        },
    ],
    announcements: [
        "Ogłaszam, ogłaszam, ogłaszam!",
        "Halo, halo!",
        "Nic z tego nie będzie...",
        "Tak mówią tylko ci, którzy mają małe wsie.",
        "Moja żona. Nie nazwałbym jej duszą towarzystwa, bardziej duszą zmarłego, która nęka po śmierci.",
        "Czekałam na prezent od męża, ale zamiast tego dał mi pieniądze i powiedział, żebym kupiła sobie to co chcę. I teraz nie mogę ich wydać, bo to moje pieniądze..."
    ],
    links: [
        {
            url: "http://www.katechizm.opoka.org.pl/kkkII-2-1.htm#o2kkkII-2-1",
            text: "Katechizm Kościoła Katolickiego – Bierzmowanie"
        }
    ],
  },
  4: {
    description: "Sakrament małżeństwa to przymierze mężczyzny i kobiety, którzy oddają się sobie wzajemnie na całe życie. Przygotowanie obejmuje nauki przedmałżeńskie i spotkania z duszpasterzem.",
    quote: "Co więc Bóg złączył, człowiek niech nie rozdziela",
    quoteAuthor: "Mt 19,6",
    image: "/assets/church_15205025.png",
    documents: [
      "Dowody osobiste",
      "Świadectwa chrztu",
      "Zaświadczenie o ukończeniu nauk przedmałżeńskich",
      "Zaświadczenia o stanie wolnym",
      "Świadectwa moralności"
    ],
    dates: [
        {
            date: "Soboty",
            rule: "Po uzgodnieniu z duszpasterzem"
        },

    ],
    documents: [
        "Dowody osobiste narzeczonych",
        "Zaświadczenie z USC lub odpis aktu małżeństwa cywilnego",
        "Świadectwa chrztu",
        "Dokument potwierdzający naukę religii i przyjęcie bierzmowania",
        "Licencja na zawarcie małżeństwa poza parafią zamieszkania – jeśli dotyczy"
    ],
    links: [
        {
            url: "http://www.katechizm.opoka.org.pl/kkkII-2-1.htm#o2kkkII-2-1",
            text: "Katechizm Kościoła Katolickiego – Małżeństwo"
        }
    ],
  },
  5: {
    description: "Sakrament pokuty i pojednania to spotkanie z miłosiernym Bogiem. W spowiedzi wyznajemy grzechy i otrzymujemy rozgrzeszenie, doświadczając Bożego miłosierdzia.",
    quote: "Pokój wam! Komu odpuścicie grzechy, są im odpuszczone",
    quoteAuthor: "J 20,21-23",
    image: "/assets/church_15205025.png",
    documents: [],
    dates: [
        {
            date: "W trakcie każdej Mszy Świętej",
        },
        {
            date: "W pierwszy piątek miesiąca od 16:30",
        }
    ],
    links: [
        {
            url: "http://www.katechizm.opoka.org.pl/kkkII-2-1.htm#o2kkkII-2-1",
            text: "Katechizm Kościoła Katolickiego – Sakrament pokuty i pojednania"
        }
    ],
  },
  6: {
    description: "Namaszczenie chorych to sakrament udzielany osobom cierpiącym na poważną chorobę lub w podeszłym wieku. Przynosi ulgę w cierpieniu i umacnia duchowo.",
    quote: "Czy ktoś wśród was choruje? Niech wezwie kapłana, a modlitwa pełna wiary uzdrowi chorego",
    quoteAuthor: "Jk 5,14-15",
    image: "/assets/church_15205025.png",
    documents: [],
    dates: [
        {
            date: "Całodobowo",
        }
    ],
    links: [
        {
            url: "http://www.katechizm.opoka.org.pl/kkkII-2-1.htm#o2kkkII-2-1",
            text: "Katechizm Kościoła Katolickiego – Namaszczenie chorych"
        }
    ],
  },
  7: {
    description: "Pogrzeb katolicki to uroczystość, podczas której żegnamy zmarłego i modlimy się za jego duszę. Obejmuje czuwanie, Mszę pogrzebową i odprowadzenie na cmentarz.",
    quote: "Ja jestem zmartwychwstaniem i życiem. Kto we Mnie wierzy, choćby i umarł, żyć będzie",
    quoteAuthor: "J 11,25",
    image: "/assets/church_15205025.png",
    documents: [
      "Akt zgonu",
      "Dowód osobisty zmarłego",
    ],
    dates: [
        {
            date: "Po uzgodnieniu z rodziną i kancelarią parafialną",
        },
    ],
    links: [
        {
            url: "http://www.katechizm.opoka.org.pl/kkkII-2-1.htm#o2kkkII-2-1",
            text: "Katechizm Kościoła Katolickiego – Pogrzeb"
        }
    ],
  }
};